<template>
  <div
    data-qa="card_getting_confirmation"
  >
    <div class="text-h6 text--text">
      Получить клубную цену
    </div>
    <div class="text-body-1 text--text mt-2 mb-6">
      Введите номер телефона — проверим,<br> в клубе ли вы
    </div>
    <UserAuthorization
      ref="user-authorization"
      persistent
      v-on="{
        [events.userAuth.confirmed]: handleEventConfirmed,
        [events.userAuth.requested]: handleCodeRequestedOnce,
      }"
    />
    <v-btn
      text
      block
      class="mt-4"
      :data-qa="dataQaCancelButton"
      @click="handleClickButton"
    >
      {{ variationBtnText }}
    </v-btn>
  </div>
</template>

<script>
import { dispatchCustomEventGlobally } from 'www/utils'
import UserAuthorization from 'www/vue_components/common/UserAuthorization/UserAuthorization.vue'
import {
  eventsData,
  getRedirectData,
} from 'www/vue_components/common/Club/components/core/ClubCardGetting/interfaces'

export default {
  name: 'ClubCardGettingConfirmation',
  components: {
    UserAuthorization,
  },
  props: {
    redirectProps: {
      type: Object,
      default: getRedirectData,
    },
  },
  data: () => ({
    events: eventsData,
    isCodeRequested: false,
  }),
  computed: {
    variationBtnText() {
      return this.redirectProps.isRedirectViaBanner
        ? 'Отменить'
        : 'Пойду по обычной цене'
    },
    dataQaCancelButton() {
      return this.redirectProps.isRedirectViaBanner
        ? 'card_getting_confirmation_btn_cancel'
        : 'card_getting_confirmation_btn_go_default'
    },
  },
  methods: {
    handleEventConfirmed(userPhone) {
      this.$emit(this.events.userAuth.confirmed, userPhone)
      dispatchCustomEventGlobally(this.events.userAuth.confirmed, { userPhone })
    },
    handleCodeRequestedOnce() {
      if (!this.isCodeRequested) {
        this.isCodeRequested = true
      }
    },
    handleClickButton() {
      if (this.redirectProps.isRedirectViaBanner) {
        this.$refs['user-authorization'].reset()
      }

      this.$emit(this.events.club.cardGettingRedirectOrCancel)
    },
  },
}
</script>
